import { useFormMutation } from "@/hooks/useFormMutation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { AnnoncementPayload } from "./validation";

export const useGetAnnoncement = (params?: string) =>
  useQuery<ApiResponse<DataPaginate<AnnoncementResponse>>>({
    queryKey: ["useGetAnnoncement", params],
    queryFn: () => fetcher(`website-config/announcements?${params}`),
  });

export const useGetAnnoncementById = (id?: number) =>
  useQuery<ApiResponse<DataObject<AnnoncementResponse>>>({
    queryKey: ["useGetVerificationById", id],
    queryFn: () => fetcher(`website-config/announcements/${id}`),
    enabled: !!id,
  });

export const useAnnoncementMutation = (id: number) => {
  return useFormMutation<
    ApiResponse<DataObject<any>>,
    Error,
    AnnoncementPayload
  >({
    mutationFn: async (payload) => {
      return await sendData(
        id
          ? `website-config/announcements/${id}`
          : `website-config/announcements`,
        payload,
        id ? "PUT" : "POST"
      );
    },
    successMessage: `Berhasil ${id ? "Mengupdate" : "Menambah"} Data`,
  });
};
